import { initCollapseComponent } from './collapse';
import { initDrawerCustom } from './drawer';
import { initModalCustom } from './modal';
import { initTabCustom } from './tab';
import { initTooltips } from './tooltip';

let initialized = false;

export function initCustoms(): void {
    if (initialized) return;
    initialized = true;
    initCollapseComponent();
    initDrawerCustom();
    initModalCustom();
    initTabCustom();
    initTooltips();
}
